import {produce} from 'immer';

import {getStructuredTableAdapters} from 'notebook/structured-tables/StructuredTableAdapters';
import {
  LastSyncedUpstreamValue,
  StructuredTableKind,
} from 'notebook/structured-tables/StructuredTableConstants';
import ProcessTaskStructuredTableAdapter, {
  ProcessTaskStructuredTable,
} from 'processes/tables/ProcessTaskStructuredTableAdapter';

import {ProcessTask} from '../__generated/ProcessTask';

/**
 * This function should only be used from the workspace tab. Tables in entries
 * are updated normally by the notebook code.
 */
export default function setRowsInTaskTable(
  table: ProcessTaskStructuredTable,
  tasks: Array<ProcessTask>,
  lastSyncedUpstreamValues: Array<Array<LastSyncedUpstreamValue>>,
  rowsAreFinalized: boolean = false
): ProcessTaskStructuredTable {
  const adapter = getStructuredTableAdapters()[
    StructuredTableKind.PROCESS_TASK
  ] as ProcessTaskStructuredTableAdapter;
  return produce(table, (draftTable) => {
    draftTable.rows = tasks.map((task, taskIndex) => ({
      ...adapter.getBlankRow(table.metadata, taskIndex, table.columns),
      ...ProcessTaskStructuredTableAdapter.makeRowFromTask(task, table.columns),
      isFinalized: rowsAreFinalized,
      metadata: adapter.getBlankRowMetadata(table.metadata),
      ...(lastSyncedUpstreamValues ? {lastSyncedUpstreamValues: lastSyncedUpstreamValues[taskIndex]} : {}),
    }));
  });
}
